import React from 'react';

type usedKeys =
  | 'createdAtSortedFilter'
  | 'expenseSorting'
  | 'expensePageSize'
  | 'reportPageSize'
  | 'transactionsColumnVisibility';

export function usePersistentState<T>(
  key: usedKeys,
): [T | undefined, (value: T | undefined) => void] {
  const [state, setState] = React.useState<T | undefined>(() => {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : undefined;
  });

  const updateState = (value: T | undefined) => {
    setState(value);
    if (value === undefined) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  };

  return [state, updateState];
}
